import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickupInstructionsLabel: {
    id: 'e8u0/5',
    description: 'Label for pickup instructions field',
    defaultMessage: 'Pickup Instructions',
  },
  driverNeedsAccessCodeLabel: {
    id: 'S53VVY',
    description: 'Label for driver needs access code checkbox',
    defaultMessage: 'Driver needs access code',
  },
  cancelButton: {
    id: 'hHNj31',
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
  },
  schedulePickupButton: {
    id: 'uQ4UQx',
    description: 'Schedule pickup button text',
    defaultMessage: 'Schedule Pickup',
  },
  fixedPickupWindowTooltip: {
    id: 'CABV69',
    description: 'Tooltip that shows after hovering over info icon when the pickup window times are fixed',
    defaultMessage: 'Pickup window is set and cannot be changed at this time.',
  },
});
